// "Today" for the puzzle is the hub's home time zone, not the device's: a
// puzzle is dated in New York, and the generator (generator/generate.mjs)
// uses the same rule, so the two never disagree about which day it is.
export function localDate(offsetDays = 0, now = new Date()) {
  const shifted = new Date(now.getTime() + offsetDays * 86400000);
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(shifted);
}
